export default "__VITE_ASSET__08878205__"